//页面组件
import ErrorPage from './views/errorPage';
import AccessErrorPage from './views/accessErrorPage';
import rule from './views/rule.vue';
import home from './views/home.vue';
import { i18n } from './i18n/setup';

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/my_awards',
    name: 'my_awards',
    component: () => import('./views/myAwards.vue'),
    meta: {
      title: i18n.t('page_my_awards')
    }
  },
  {
    path: '/account_error',
    name: 'account_error',
    component: ErrorPage,
    meta: {
      title: i18n.t('page_account_error')
    }
  },
  {
    path: '/access_error',
    name: 'access_error',
    component: AccessErrorPage,
    meta: {
      title: i18n.t('page_access_error')
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('./views/contact.vue'),
    meta: {
      title: '填写地址'
    }
  },
  {
    path: '/rule',
    name: 'rule',
    component: rule,
    meta: {
      title: i18n.t('page_rule')
    }
  }
];

export default routes;
